import { Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { WorkOrderPriority } from 'vendor-marketplace-shared-library';
import SecondaryButton from '../../../components/common/styled-mui-overrides/SecondaryButton';
import PrimaryButton from '../../../components/common/styled-mui-overrides/PrimaryButton';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DatePicker } from '@mui/x-date-pickers';
import { UpdateWorkOrderFormData } from '../CreateWorkOrderFormPage';

type CreateWorkOrderWhenProps = {
  workOrderId: string;
  priorities: WorkOrderPriority[];
  formData: Partial<UpdateWorkOrderFormData>;
  setFormData: (data: Partial<UpdateWorkOrderFormData>) => void;
  onSubmit: () => void;
};

export default function CreateWorkOrderWhen(props: CreateWorkOrderWhenProps) {
  const navigate = useNavigate();
  return (
    <Grid container sx={{ justifyContent: 'center', paddingTop: 4 }}>
      <Grid item xs={0} md={3}></Grid>
      <Grid item container xs={12} md={6} spacing={2} sx={{ justifyContent: 'center' }}>
        <Grid container item xs={12} spacing={2} sx={{ justifyContent: 'center' }}>
          <Grid item>
            <InputLabel>Due date</InputLabel>
            <DatePicker
              value={props.formData.dueDate || null}
              onChange={newValue => props.setFormData({ ...props.formData, dueDate: newValue })}
            />
          </Grid>

          <Grid item>
            <InputLabel>Priority status</InputLabel>

            <Select
              name={'assignedUserId'}
              fullWidth
              value={props.formData.workOrderPriorityId}
              onChange={e =>
                props.setFormData({
                  ...props.formData,
                  workOrderPriorityId: e.target.value,
                })
              }
            >
              {props.priorities.map((priority: WorkOrderPriority) => (
                <MenuItem key={priority.id} value={priority.id}>
                  {priority.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
        <Grid item>
          <SecondaryButton
            onClick={() => navigate(`/create-work-order/${props.workOrderId}/?step=3`)}
          >
            Back
          </SecondaryButton>
        </Grid>

        <Grid item>
          <PrimaryButton
            onClick={() => {
              props.onSubmit();
              navigate('/');
            }}
          >
            Next
          </PrimaryButton>
        </Grid>
      </Grid>
      <Grid item xs={0} md={3}></Grid>
    </Grid>
  );
}
